import { render, staticRenderFns } from "./NumberRow.vue?vue&type=template&id=c2b8ac34&"
import script from "./NumberRow.vue?vue&type=script&lang=js&"
export * from "./NumberRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports